/**
 * Copyright 2026 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import React from "react";
import { Box, Chip, Tooltip, Typography } from "@mui/material";

const ChipList = ({ chips, maxLength }) => {
  const shownItems = chips.slice(0, maxLength);
  const rest = chips.slice(maxLength);

  return (
    <Box>
      {shownItems.map((chip) => (
        <Chip key={`chip-${chip}`} label={chip} size="small" sx={{ mr: 1 }} />
      ))}
      {rest.length > 0 && (
        <Tooltip
          title={rest.map((r) => (
            <Typography key={`cl-tt-${r}`} variant="body1" component="div">
              {r}
            </Typography>
          ))}
          arrow
        >
          <Chip label="..." size="small" sx={{ cursor: "pointer" }} />
        </Tooltip>
      )}
    </Box>
  );
};

export default ChipList;
